import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-search-customer-dialog',
  templateUrl: './search-customer-dialog.component.html',
  styleUrls: ['./search-customer-dialog.component.css']
})
export class SearchCustomerDialogComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
